<div class="container" style="position: relative">
	<div style="display:flex; justify-content:space-between; align-items:center">
		<span (click)="backClicked()"
			style="display:flex; justify-content:space-between; align-items:center; cursor: pointer; margin-bottom: 10px;">
			<vng-icon name="keyboard_arrow_left" [outline]="false"></vng-icon><strong>Payment Details</strong>
		</span>
	</div>
	<form>
		<div class="payment-info"
			style="display:flex; justify-content:space-between; align-items:flex-start; gap:1.25rem">
			<vng-card variant="outline" style="flex:1 1 100%; max-width:100%">
				<h3 class="no-left-margin" style="margin-left: 0 !important">
					Payment Method
				</h3>
				<vng-divider></vng-divider>
				<div class="credit-card-info" style="display:flex; flex-direction:column">
					<strong class="title">Credit card information</strong>
					<!-- Stripe Elements Placeholder -->
					<div class="my-input" #paymentElement></div>
					<!-- <vng-checkbox >Save card</vng-checkbox> -->
					<vng-input label="Name on Card" placeholder="Name on Card" style="margin-top: 15px;"
						[(ngModel)]="name" name="name"></vng-input>
				</div>
				<vng-divider></vng-divider>
				<div class="billing-info" style="display:flex; flex-direction:column">
					<strong class="title">Billing details</strong>
					<vng-input label="Address Line 1" placeholder="Address Line 1" [(ngModel)]="add1"
						name="add1"></vng-input>
					<vng-input label="Address Line 2" placeholder="Address Line 2" [(ngModel)]="add2"
						name="add2"></vng-input>

					<!-- <vng-select label="City" [(ngModel)]="city" name="city" [options]="stateCityOptions"></vng-select> -->
					<vng-input label="City" placeholder="City" [(ngModel)]="city" name="city"></vng-input>

					<!-- <vng-select label="State" [(ngModel)]="state" name="state" [options]="countryStateOptions" (selectionChange)="updateCities($event)"></vng-select> -->
					<vng-input label="State" placeholder="State" [(ngModel)]="state" name="state"></vng-input>

					<vng-select label="Country" placeholder="Country" [(ngModel)]="country" name="country"
						[options]="countryOptions" (selectionChange)="updateStates($event)"></vng-select>
					<vng-input label="Zip Code" placeholder="Zip Code" style="width: 50%;" [(ngModel)]="zip"
						name="zip"></vng-input>
				</div>
			</vng-card>
			<div style="flex:1 1 100%; max-width:40%" class="small-payment">
				<!-- issue #608 F-1/F-4/F-5: a plan/interval absent from
				     v1/subscriptions/plans (contact-sales-only, same mechanism as
				     #604's new-plan card) has no price to show here —
				     `calculatePayment()` leaves planAmount at its `0` default
				     rather than the previous raw `undefined`, but `0` is
				     just as made-up a price as the old "$0.00" Pay. Instead this
				     whole figure set (Plan Type amount, and all of #601's preview
				     rows: Discount, Total, credit note, Due today, the renewal line,
				     "Calculating your price…", the preview Retry and Pay) is replaced with the same "Contact sales" CTA #604 shows on
				     /new-plan, keeping ".order-review" itself and the payment form on
				     the left unconditional — a direct/bookmarked link to this page
				     for an unpriced plan still needs somewhere to land.

				     F-4/F-5 (round 2): the Contact sales CTA (and the priced figures
				     it replaces) only ever render once `plansLoadState === 'ready'` —
				     mirroring /new-plan's own gate — so a priced plan can never flash
				     "available through our sales team" while the catalogue is still
				     loading or after it failed to load. The `.plans-load-error` class
				     on both the error block and the Contact sales block reuses #604's
				     64px icon override (payment-details.component.scss) so neither one
				     covers its own button on desktop. -->
				<vng-card variant="outline" class="order-review secure-pay">
					<ng-container [ngSwitch]="plansLoadState">
						<div *ngSwitchCase="'loading'" data-testid="plans-loading">
							<ngx-skeleton-loader count="2" appearance="line"
								[theme]="{ 'border-radius': '8px', height: '48px', margin: '0 0 1rem' }"></ngx-skeleton-loader>
						</div>

						<div *ngSwitchCase="'error'" class="plans-load-error" data-testid="plans-load-error"
							role="alert">
							<app-empty-state icon="icon-ico-info" heading="We couldn't load our plans"
								subtext="Please check your connection and try again."></app-empty-state>
							<div style="display:flex; justify-content:center">
								<button vng-button variant="primary" type="button" data-testid="plans-load-retry"
									(click)="retryPlansLoad()">Try again</button>
							</div>
						</div>

						<ng-container *ngSwitchCase="'ready'">
							<ng-container *ngIf="!isContactSalesOnly; else contactSalesReview">
								<div style="display:flex; flex-direction:column; gap:0.5rem" [style.margin-bottom]="'15px'">
									<strong class="title">Order review</strong>
									<div style="display:flex; justify-content:space-around; align-items:center">
										<vng-input id="discount-code" label="Discount Code" placeholder="Discount Code"
											style="width: 100%; margin-right: 20px;" [(ngModel)]="discountCode"
											(keyup)="onKeyUp($event)" name="discountCode"></vng-input>
										<button style="width: 100px;" vng-button variant="primary" (click)="apply()">
											Apply
										</button>
									</div>
									<div *ngIf="discountCodeLabel || discountCodeInvalid || discountCodeNotSupplied"
										style="background: #F9F9F9;">
										<!-- issue #601 round-5 QA L-1r: `discountCodeLabel` names ONLY
											the code the CURRENT preview actually confirmed and priced —
											never a code whose validation was ignored (stale) or is still
											in flight, no matter how the field changed (keystroke, paste,
											autofill, or a programmatic write). -->
										<span *ngIf="discountCodeLabel && !discountCodeInvalid" class="feedback success">
											Discount code “{{discountCodeLabel}}” was applied
										</span>

										<span *ngIf="discountCodeInvalid" class="feedback error">
											Discount code is not valid or has expired.
										</span>

										<span *ngIf="discountCodeNotSupplied" class="feedback error">
											Input a discount code to apply for discount
										</span>
									</div>
								</div>

								<div style="display:flex; flex-direction:column; gap:1.25rem">
									<div class="review-row"
										style="display:flex; justify-content:space-between; align-items:flex-end">
										<div>
											<small style="text-align: left !important">Plan Type</small>
											<p>{{ planTypeDisplay }}</p>
										</div>

										<p>${{ formatPrice(planAmount) }}{{checked ? '/month' : '/year'}}</p>
									</div>

									<!-- Issue #599: every figure below this point comes from
										flymsg-node's preview-change (Stripe's own proration/discount
										math) — never a client-side list-minus-coupon calculation. -->
									<ng-container *ngIf="preview">
										<!-- Issue #601 round-2 QA G-03/R-08: Stripe can fold a real,
											applied coupon's effect into the proration line items on a
											same-interval change instead of a standalone discount total
											— hide this row rather than show a misleading "0.00" next
											to the applied code when that happens. -->
										<div class="review-row" *ngIf="discountVisible"
											style="display:flex; justify-content:space-between; align-items:flex-end">
											<!-- Issue #601 round-7 QA L-3: names the code the CURRENT
												preview actually priced (`validatedPreviewCoupon`, the
												same confirmed source `discountCodeLabel` above uses) —
												never `appliedDiscountCode`, which `apply()` writes
												optimistically before validation answers and never
												unwinds on a stale/ignored answer (see `apply()`'s doc
												comment). -->
											<small>Discount <span *ngIf="validatedPreviewCoupon">({{validatedPreviewCoupon}})</span></small>
											<p>{{discountDisplay}}</p>
										</div>
										<div class="review-row"
											style="display:flex; justify-content:space-between; align-items:flex-end">
											<!-- Issue #601 G-03: Total is a one-time prorated invoice
												figure, never a recurring rate — no "/month" or "/year"
												suffix (that belongs to the Plan Type row above). A
												downgrade/yearly->monthly credit renders as a signed
												"-$X.XX", never "$-X.XX/month". -->
											<small>Total</small>
											<p>{{totalDisplay}}</p>
										</div>
										<!-- Issue #601 round-2 QA G-03/R-08: a negative Total is a
											Stripe balance credit, never a refund to the card — say so
											next to it so "-$X.XX" is never misread as money coming
											back. -->
										<div class="review-row" *ngIf="totalIsCredit"
											style="display:flex; justify-content:flex-end">
											<small>Applied as account credit toward a future invoice — not refunded to your card</small>
										</div>
										<div class="review-row"
											style="display:flex; justify-content:space-between; align-items:flex-end">
											<strong>Due today</strong>
											<strong>${{dueTodayDisplay}}</strong>
										</div>
										<div class="review-row renewal-line" *ngIf="renewalDate"
											style="display:flex; justify-content:flex-end">
											<small>then ${{renewalAmountDisplay}}{{checked ? '/month' : '/year'}} from
												{{renewalDate.format('D MMM YYYY')}}</small>
										</div>
									</ng-container>

									<div class="preview-loading" *ngIf="previewLoading" role="status"
										style="display:flex; justify-content:flex-end">
										<small>Calculating your price…</small>
									</div>

									<div class="preview-failed feedback error" *ngIf="previewFailed && !previewLoading"
										style="display:flex; flex-direction:column; align-items:flex-end; gap:0.5rem">
										<small>We couldn't calculate your price right now.</small>
										<button type="button" vng-button variant="secondary" (click)="retryPreview()">
											Retry
										</button>
									</div>

									<!-- Issue #609 AC-3: flymsg-be #983's still-confirming 403 puts the
										page in a calm, non-error waiting state — never the error toast,
										never an immediate blind retry. -->
									<div class="checkout-pending feedback" *ngIf="checkoutPending" role="status"
										data-testid="checkout-pending"
										style="display:flex; flex-direction:column; align-items:flex-end; gap:0.5rem">
										<small>{{checkoutPendingMessage}}</small>
										<a [routerLink]="['/settings']" [queryParams]="{tab: 'subscription'}">Check subscription status</a>
									</div>

									<button vng-button variant="primary"
										[disabled]="loading || previewLoading || previewFailed || !preview || (checkoutPending && !pendingTimedOut)"
										(click)="confirmPaymentSetup()" [attr.data-secret]="client_secret" #cardButton>
										<span *ngIf="checkoutPending && !pendingTimedOut">Confirming…</span>
										<span *ngIf="checkoutPending && pendingTimedOut">Try again</span>
										<span *ngIf="!checkoutPending && preview && !previewLoading">Pay ${{dueTodayDisplay}}</span>
										<span *ngIf="!checkoutPending && previewLoading">Calculating…</span>
										<span *ngIf="!checkoutPending && previewFailed && !previewLoading">Price unavailable</span>
									</button>
								</div>
							</ng-container>
							<ng-template #contactSalesReview>
								<div class="plans-load-error" style="display:flex; flex-direction:column; gap:1.25rem"
									data-testid="plan-contact-sales">
									<app-empty-state icon="icon-ico-info" heading="Contact sales"
										subtext="This plan is available through our sales team."></app-empty-state>
									<div style="display:flex; justify-content:center">
										<button vng-button variant="primary" type="button"
											data-testid="plan-contact-sales-link" (click)="contactSales()">Contact
											sales</button>
									</div>
								</div>
							</ng-template>
						</ng-container>
					</ng-container>
				</vng-card>
				<small>Payments are secured by Stripe</small>
			</div>
		</div>
	</form>
	<ngx-ui-loader [loaderId]="paymentDetailsId"></ngx-ui-loader>
</div>